import { Box, Flex, Heading4, IconicButton } from "@nulogy/components";
import React, { useState } from "react";

export default function CollapsibleSection({ title, children, className, isOpen, onToggle }) {
  const [sectionOpen, setSectionState] = useState(isOpen);

  const toggle = () => {
    setSectionState(!sectionOpen);
    onToggle();
  };

  const icon = sectionOpen ? "downArrow" : "rightArrow";

  return (
    <Box className={className} marginBottom="x5">
      <Flex alignItems="center" marginBottom="x1">
        <Heading4 color="midGrey" fontWeight="medium" mb="0px" mr="x1">
          {title}
        </Heading4>
        <IconicButton
          color="midGrey"
          data-testid="collapsible-section-toggle"
          icon={icon}
          onClick={() => toggle()}
          py={0}
          size="x3"
          type="button"
        />
      </Flex>
      {sectionOpen && <Box>{children}</Box>}
    </Box>
  );
}
